<template>
  <div class="wx-share">
    <el-dialog title="" v-model="showModal" size="tiny" custom-class="wx-share-modal" @close="closeModal">
      <div class="wx-share-body">
        <div class="left">
          <div class="step">01</div>
          <div class="desc">打开微信，扫描二维码</div>
          <div class="qrcode" :style="'background-image:url('+url+')'"></div>
          <div class="ap-name">赴馆通知书 - {{names}}</div>
          <div class="tips" v-if="order.need_interview">（含面试培训视频）</div>
        </div>
        <div class="center">
          <img src="../../assets/imgs/admin-order/arrow.png">
        </div>
        <div class="right">
          <div class="step">02</div>
          <div class="desc">点击底部「分享给顾客」</div>
          <img class="share-phone" v-if="order.need_interview" src="../../assets/imgs/admin-order/phone.png" height="409">
          <img class="share-phone" v-if="order.need_delivery" src="../../assets/imgs/admin-order/need_delivery.png" height="409">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { env } from '../../libs/env';

export default {
  name: 'wxShare',
  props: ['show', 'url', 'names', 'order'],
  data() {
    return {
      env,
      showModal: false,
    };
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less">
.wx-share {
  .wx-share-modal {
    width: 632px;
    background-color: transparent;
    top: 56% !important;
    transform: translate(-50%, -50%);

    .el-dialog__header,
    .el-dialog__body {
      padding: 0;
      position: relative;
    }

    .el-dialog__headerbtn {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 100;
      transform: scale(0.8);
    }

    .el-dialog__close {
      color: #aaa;
    }

    .wx-share-body {
      line-height: 1;
      width: 632px;
      height: 470px;
      background-color: white;
      border-radius: 6px;
      position: relative;
      padding: 20px 80px;
      display: flex;
      .step {
        background-image: url('../../assets/imgs/number.png');
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #fff;
        height: 40px;
        width: 40px;
        padding-bottom: 5px;
      }
      .desc {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        margin-top: 10px;
        display: flex;
        justify-content: center;
      }
      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        .qrcode {
          margin-top: 45px;
          width: 200px;
          height: 197px;
          border: 1px solid #f0f0f0;
          background-size: 100%;
        }
        .ap-name {
          font-size: 14px;
          color: #333;
          margin-top: 12px;
          width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
        .tips {
          margin-top: 10px;
          font-size: 12px;
          color: #aaa;
        }
      }
      .center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 5px;
        padding-bottom: 30px;
      }
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
        .share-phone {
          margin-top: 20px;
          height: 345px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/wx-share.vue